import React from 'react';
import { storiesOf } from '@storybook/react';
import { action } from '@storybook/addon-actions';
import History from './History';
import historyArray from './HistoryArray';

// TODO: remove when removing from TextHighlight.jsx
window.$ = () => ({
  highlight: () => {},
  removeHighlight: () => {},
});

const emptyProps = {
  case_uuid: 'azbtest_2644',
  purchase_right_away: false,
  history: [],
  noDataFoundMessage: 'There are no transactions.',
  dataReady: true,
  dispatch: null,
  lastUpdated: 1000,
  error: null,
  receipt: null,
  dockets: {
    data: [],
    dataReady: false,
    error: {},
    lastUpdated: '',
  },
};

const sampleHistorysProps = {
  case_uuid: 'azbtest_2644',
  closeEmailNotification: () => action('closeEmailNotification'),
  currentUser: "1",
  dataReady: true,
  dispatch: () => action('dispatch'),
  displayLoader: "",
  docketFilterProps: {keyword: "", doc_range: "", startDate: null, endDate: null, onChange: () => action('onChange'), changeDate: () => action('changeDate'), onChangeDateRaw: () => action('onChangeDateRaw')},
  docketParts: {step: 0, purchased: 0, parts_to_purchase: 0, total_cost: 0, parts: 0, },
  error: {},
  getDocketData: () => action('getDocketData'),
  getDocketDatafromPacer: () => action('getDocketDatafromPacer'),
  getDocketDetails: () => action('getDocketDetails'),
  history: {total_pages: 10.01, page_size: 100, total_items: 1001, entries: historyArray, favoriteEmail: "rimzoni@gmail.com"},
  historyEntriesProps: {entries: Array(100), history: {total_pages: 10.01, page_size: 100, total_items: 1001, entries: historyArray, favoriteEmail: "rimzoni@gmail.com"}, redactSeqNum: undefined, buyMissingDockets: undefined, getDocketDetails: () => action('getDocketDetails'), sortHistory: () => action('sortHistory')},
  historyPaginatorProps: {history: {total_pages: 10.01, page_size: 100, total_items: 1001, entries: historyArray, favoriteEmail: "rimzoni@gmail.com"}, case_uuid: "debke_156594", selectedPageNum: 1, changePage: () => action('changePage'), dispatch: () => action('dispatch')},
  lastUpdated: undefined,
  noDataFoundMessage: "No Transactions found.",
  onPopupClick: () => action('onPopupClick'),
  onSubmit: () => action('onSubmit'),
  onSubmitParser: () => action('onSubmitParser'),
  popup: {name: "EmailCombinedPdfPopup", show: false, data: historyArray},
  purchaseData: () => action('purchaseData'),
  purchase_right_away: false,
  receipt: null,
  sendDocketViaEmail: () => action('sendDocketViaEmail'),
  showEmailNotification: false,
  showEmailPopup: false,
  showPacerFilterSection: true,
  showPubliclinkPopup: false,
  tableSortProps: {sort_direction: "desc", sort_field: "date_filed"},
  toggleEmailPopup: () => action('toggleEmailPopup'),
  togglePacerFilterSection: () => action('togglePacerFilterSection'),
  togglePublicLinkPopup: () => action('togglePublicLinkPopup'),
  type: "history"
};

const sampleHistorysWithDocketsProps = {

};

const sampleDocketsEmailProps = {
 
};

const sampleDocketsPubliclProps = {
 
};

storiesOf('Case Menu/History', module)
  .add('Loading', () => (
    <div>
      <h3>Component can be in a loading state while we fetch data</h3>
      <hr />
      <History />
    </div>
  ))

  .add('View', () => (
    <div>
      <h3>By default, we show a list of history received form the parser API</h3>
      <hr />
      <h4>Page contains 'Find What' input that searches through table of data.</h4>
      <h4>There is 'Premium Search' button, which leads to the premium search url.</h4>
      <h4>There is 'Pacer filter' section, that searches transactions from pacer api.</h4>
      <h4>There is 'Parser filter' section, that searches transactions from parser api.</h4>
      <h4>We can refresh list by clicking the 'Update from Pacer' button</h4>
      <hr />

      <History
        {...sampleHistorysProps}
       />
    </div>
  ));
  // .add('View Docket Details', () => (
  //   <div>
  //     <h3>On click docket number Docket Details row is being displayed</h3>
  //     <hr />
  //     <History
  //       {...sampleHistorysWithDocketsProps}
  //       purchaseData={action('purchaseData')}
  //      />
  //   </div>
  // ))
  // .add('View Docket Details - email popup', () => (
  //   <div>
  //     <h3>On click email icon Share Docket popup is displayed</h3>
  //     <hr />
  //     <History
  //       {...sampleDocketsEmailProps}
  //       purchaseData={action('purchaseData')}
  //      />
  //   </div>
  // ))
  // .add('View Docket Details - public link popup', () => (
  //   <div>
  //     <h3>On click email icon Public Link popup is displayed</h3>
  //     <hr />
  //     <History
  //       {...sampleDocketsPubliclProps}
  //       purchaseData={action('purchaseData')}
  //      />
  //   </div>
  // ))
  // .add('No Data', () => (
  //   <div>
  //     <h3>If there is no data found, message is displayed.</h3>
  //     <hr />
  //     <h4>We can refresh list by clicking the 'Update from Pacer' button</h4>
  //     <hr />

  //     <History {...emptyProps} />
  //   </div>
  // ));


// WEBPACK FOOTER //
// ./src/components/case/history/History.stories.jsx